import React from "react";
import { string } from "prop-types";

function Padlock({ color, ...restProps }) {
  return (
    <svg viewBox="0 0 24 24" {...restProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 15C11.9477 15 11.5 15.4477 11.5 16C11.5 16.5523 11.9477 17 12.5 17C13.0523 17 13.5 16.5523 13.5 16C13.5 15.4477 13.0523 15 12.5 15ZM10.5 16C10.5 14.8954 11.3954 14 12.5 14C13.6046 14 14.5 14.8954 14.5 16C14.5 17.1046 13.6046 18 12.5 18C11.3954 18 10.5 17.1046 10.5 16Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 20C12.2239 20 12 19.7761 12 19.5L12 17.5C12 17.2239 12.2239 17 12.5 17C12.7761 17 13 17.2239 13 17.5L13 19.5C13 19.7761 12.7761 20 12.5 20Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 11.5C4 10.6716 4.67157 10 5.5 10H19.5C20.3284 10 21 10.6716 21 11.5V21.5C21 22.3284 20.3284 23 19.5 23H5.5C4.67157 23 4 22.3284 4 21.5V11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5V21.5C5 21.7761 5.22386 22 5.5 22H19.5C19.7761 22 20 21.7761 20 21.5V11.5C20 11.2239 19.7761 11 19.5 11H5.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2C10.567 2 9 3.567 9 5.5H8C8 3.01472 10.0147 1 12.5 1C14.9853 1 17 3.01472 17 5.5H16C16 3.567 14.433 2 12.5 2Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10.5V5.5H9V10.5H8Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10.5V5.5H17V10.5H16Z"
        fill={color}
      />
    </svg>
  );
}

Padlock.propTypes = {
  color: string.isRequired,
};

export default Padlock;
